module.exports = __webpack_public_path__ + "img/promo-header-img.a81792df.jpg";